export default __webpack_public_path__ + "8574439590d3d2429a09a82472d1936d.gif";